
/**
 * 트렌드 통계 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemStats = {
  count?: number;
};
